import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["score", "body", "restored", "fromDraft"]
  static values = { key: String, signedIn: Boolean, name: String }

  connect() {
    const draft = this.#read()
    if (!draft || this.#hasInput) return

    const { pending, ...input } = draft
    this.scoreTarget.value = input.score
    this.bodyTarget.value = input.body
    this.restoredTarget.classList.remove("hidden")
    if (this.hasFromDraftTarget) this.fromDraftTarget.value = "true"
    if (pending && this.signedInValue) {
      this.#write(input)
      this.restoredTarget.scrollIntoView({ block: "center" })
    }
  }

  save() {
    if (this.#hasInput) {
      this.#write({ score: this.scoreTarget.value, body: this.bodyTarget.value, name: this.nameValue })
    } else {
      this.#remove()
    }
  }

  markPending() {
    const draft = this.#read()
    if (draft) this.#write({ ...draft, pending: true })
  }

  discard() {
    this.#remove()
    this.scoreTarget.value = ""
    this.bodyTarget.value = ""
    this.restoredTarget.classList.add("hidden")
    if (this.hasFromDraftTarget) this.fromDraftTarget.value = "false"
  }

  forget({ detail: { success, fetchResponse } }) {
    if (success && fetchResponse.location.pathname === window.location.pathname) this.#remove()
  }

  get #hasInput() {
    return this.scoreTarget.value !== "" || this.bodyTarget.value !== ""
  }

  get #storageKey() {
    return `review-draft:${this.keyValue}`
  }

  // cookie を禁止した環境では localStorage の参照自体が例外になる (analytics.js と同じ)。そのときは下書きを残さない
  #read() {
    try {
      return JSON.parse(localStorage.getItem(this.#storageKey))
    } catch {
      return null
    }
  }

  #write(draft) {
    try {
      localStorage.setItem(this.#storageKey, JSON.stringify(draft))
    } catch {}
  }

  #remove() {
    try {
      localStorage.removeItem(this.#storageKey)
    } catch {}
  }
}
